
export default {
  name: "RightToWorkCheck",
  props: {
    baseUrl: { type: String, required: true },
    officerId: { type: Number, required: true },
    officerName: { type: String, default: "" }
  },
  emits: ["close", "saved"],
  data() {
    return {
      current: {} as any,
      shareCode: "",
      dateOfBirth: "",
      checking: false,
      checkResult: null as any,
      status: "",
      validUntil: "",
      lastCheckedAt: "",
      saving: false,
      message: "",
      messageType: ""
    };
  },
  watch: {
    officerId: {
      immediate: true,
      handler() {
        this.fetchCurrent();
      }
    }
  },
  methods: {
    authHeaders() {
      const token = localStorage.getItem("token");
      return {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json"
      };
    },
    formatDate(value: string | null): string {
      return value ? new Date(value).toLocaleDateString("en-GB") : "";
    },
    formatDateTime(value: string | null): string {
      return value ? new Date(value).toLocaleString("en-GB") : "";
    },
    // "YYYY-MM-DDTHH:mm" in local time, as datetime-local inputs expect
    toLocalInputValue(date: Date): string {
      const pad = (n: number) => String(n).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
    },
    async fetchCurrent() {
      if (!this.officerId) {
        return;
      }
      try {
        const response = await fetch(`${this.baseUrl}RightToWork/${this.officerId}`, {
          method: "GET",
          headers: this.authHeaders()
        });
        if (response.ok) {
          this.current = await response.json();
          this.dateOfBirth = (this.current.dateOfBirth || "").split("T")[0];
          this.shareCode = this.current.shareCode || "";
          this.status = this.current.status || "";
          this.validUntil = (this.current.validUntil || "").split("T")[0];
        } else {
          this.message = "Failed to load right to work details.";
          this.messageType = "alert-danger";
        }
      } catch (error) {
        console.error("Error loading right to work details:", error);
        this.message = "Network error while loading right to work details.";
        this.messageType = "alert-danger";
      }
    },
    async runCheck() {
      this.checking = true;
      this.checkResult = null;
      this.message = "";
      try {
        const response = await fetch(`${this.baseUrl}RightToWork/${this.officerId}/Check`, {
          method: "POST",
          headers: this.authHeaders(),
          body: JSON.stringify({ shareCode: this.shareCode.trim(), dateOfBirth: this.dateOfBirth || null })
        });
        if (response.ok || response.status === 422) {
          this.checkResult = await response.json();
          if (this.checkResult.success) {
            this.lastCheckedAt = this.toLocalInputValue(new Date(this.checkResult.checkedAtUtc));
          }
        } else {
          this.message = response.status === 400 ? await response.text() : "The right to work check failed. Please try again.";
          this.messageType = "alert-danger";
        }
      } catch (error) {
        console.error("Error running right to work check:", error);
        this.message = "Network error while running the check.";
        this.messageType = "alert-danger";
      } finally {
        this.checking = false;
      }
    },
    async saveStatus() {
      this.saving = true;
      this.message = "";
      try {
        const response = await fetch(`${this.baseUrl}RightToWork/${this.officerId}/Status`, {
          method: "POST",
          headers: this.authHeaders(),
          body: JSON.stringify({
            status: this.status,
            validUntil: this.validUntil || null,
            lastCheckedAt: new Date(this.lastCheckedAt).toISOString()
          })
        });
        if (response.ok) {
          this.message = "Right to work saved.";
          this.messageType = "alert-success";
          await this.fetchCurrent();
          this.$emit("saved");
        } else {
          this.message = response.status === 400 ? await response.text() : "Failed to save right to work.";
          this.messageType = "alert-danger";
        }
      } catch (error) {
        console.error("Error saving right to work:", error);
        this.message = "Network error while saving right to work.";
        this.messageType = "alert-danger";
      } finally {
        this.saving = false;
      }
    }
  }
};
